import { Slot } from "@cur8/rich-entity";
import { useVisitPrerequisites } from "render/hooks/api/useVisitPrerequisites";
import { useTracking } from "render/hooks/useTracking";
import { Expandable } from "render/ui/presentation/Expandable";
import { Typography } from "render/ui/presentation/Typography";
import { ActionButton } from "render/ui/trigger/ActionButton";
import { appointmentEvents } from "../../tracking";
import { Trans } from "../../trans";
import styles from "./styles.module.sass";

interface CompleteProfileButtonProps {
  slot: Slot;
  visitId: string;
}

export function CompleteProfileButton({
  slot,
  visitId,
}: CompleteProfileButtonProps) {
  const { trackEvent } = useTracking();
  const { isReady, getNextStep } = useVisitPrerequisites({
    origin: "appointment",
    visitId,
  });

  return (
    <Expandable isOpen={isReady === false}>
      <ActionButton
        disabled={isReady}
        onClick={() => {
          trackEvent(appointmentEvents.completeProfileClick());
          getNextStep()?.(slot.slotId);
        }}
        variant="suggestion"
      >
        <div className={styles.profileCompleteButtonText}>
          <Typography variant="body-label-m">
            <Trans.CompleteProfileButton.Title />
          </Typography>
          <Typography variant="body-xs" color="inverted">
            <Trans.CompleteProfileButton.Sub />
          </Typography>
        </div>
      </ActionButton>
    </Expandable>
  );
}
